import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type State = Record<string, boolean>;

const progressSlice = createSlice({
  name: 'options',
  initialState: {} as State,
  reducers: {
    startTask(state, action: PayloadAction<{ taskName: string }>) {
      state[action.payload.taskName] = true;
    },
    endTask(state, action: PayloadAction<{ taskName: string }>) {
      state[action.payload.taskName] = false;
    },
  },
});

const { startTask, endTask } = progressSlice.actions;

export { startTask, endTask };
export default progressSlice.reducer;
